import React, { useState } from "react";
import { Command } from "../services/api";

interface CommandsProps {
  commands: { slash?: Command[]; prefix?: Command[] } | Command[];
  loading: boolean;
}

export const Commands: React.FC<CommandsProps> = ({ commands, loading }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState<"all" | "slash" | "prefix">("all");
  const [selectedCategory, setSelectedCategory] = useState<string>("all");

  if (loading) {
    return <div className="loading">Caricamento elenco comandi...</div>;
  }

  // Normalize commands structure
  let slashList: Command[] = [];
  let prefixList: Command[] = [];

  if (Array.isArray(commands)) {
    slashList = commands;
  } else if (commands) {
    slashList = commands.slash || [];
    prefixList = commands.prefix || [];
  }

  const allCommands = [
    ...slashList.map((c) => ({ ...c, type: "slash" as const })),
    ...prefixList.map((c) => ({ ...c, type: "prefix" as const })),
  ];

  // Categories list
  const categories = Array.from(new Set(allCommands.map((c) => c.category || "Generale")));

  // Filter commands
  const filtered = allCommands.filter((cmd) => {
    const matchesSearch =
      cmd.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (cmd.description && cmd.description.toLowerCase().includes(searchTerm.toLowerCase()));
    const matchesType = selectedType === "all" || cmd.type === selectedType;
    const matchesCat = selectedCategory === "all" || (cmd.category || "Generale") === selectedCategory;
    return matchesSearch && matchesType && matchesCat;
  });

  return (
    <div className="tab-content">
      <div className="card-header-row">
        <div>
          <h2>Elenco Comandi ({allCommands.length})</h2>
          <p className="subtitle">Comandi Slash (/) e con prefisso disponibili nel bot</p>
        </div>
      </div>

      {/* Filter Bar */}
      <div className="filter-bar">
        <input
          type="text"
          placeholder="🔍 Cerca comando o descrizione..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />

        <div className="filter-buttons">
          <button
            className={`filter-btn ${selectedType === "all" ? "active" : ""}`}
            onClick={() => setSelectedType("all")}
          >
            Tutti ({allCommands.length})
          </button>
          <button
            className={`filter-btn ${selectedType === "slash" ? "active" : ""}`}
            onClick={() => setSelectedType("slash")}
          >
            Slash / ({slashList.length})
          </button>
          <button
            className={`filter-btn ${selectedType === "prefix" ? "active" : ""}`}
            onClick={() => setSelectedType("prefix")}
          >
            Prefisso ! ({prefixList.length})
          </button>
        </div>

        <select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          className="select-input category-filter"
        >
          <option value="all">Tutte le Categorie</option>
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      {filtered.length === 0 ? (
        <div className="empty-state">
          <p>Nessun comando corrisponde ai criteri di ricerca.</p>
        </div>
      ) : (
        <div className="commands-grid">
          {filtered.map((cmd) => (
            <div key={`${cmd.type}-${cmd.name}`} className="command-card">
              <div className="command-card-header">
                <div className="command-name-wrap">
                  <span className="command-prefix-symbol">
                    {cmd.type === "slash" ? "/" : "!"}
                  </span>
                  <span className="command-name-title">{cmd.name}</span>
                </div>
                <div className="command-badges">
                  <span className="category-pill">{cmd.category || "Generale"}</span>
                  {cmd.adminOnly && <span className="admin-pill">Admin</span>}
                  {cmd.ownerOnly && <span className="owner-pill">Owner</span>}
                </div>
              </div>

              <p className="command-description">{cmd.description || "Nessuna descrizione"}</p>

              <div className="command-meta-row">
                <span className="meta-item">⏱️ Cooldown: {cmd.cooldown || 3}s</span>
                {cmd.aliases && cmd.aliases.length > 0 && (
                  <span className="meta-item">Alias: {cmd.aliases.join(", ")}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
